module.exports = {
      id: "comm-automobile-usage",
      viewBox: "0 0 231.941 38.7",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#comm-automobile",
      toString: function () {
        return this.url;
      }
    }